<template>
  <f7-page @page:beforein="pageBeforeIn">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left" />
      </f7-nav-left>
      <f7-nav-title>菜單管理</f7-nav-title>
    </f7-navbar>

    <f7-list media-list>
      <f7-list-item title="已發佈" divider />
      <f7-list-item
        v-for="(menu, index) in menuVariations"
        :key="`menu-list-released-menu-variations-${index}`"
        :title="`${menu.variationTitle}`"
        :subtitle="menu.variation"
        :after="`目前版本: ${menu.version}`"
        swipeout>
        <f7-swipeout-actions right>
          <f7-swipeout-button
            close
            color="green"
            @click="navigateToMenuPage(menu.variation)">
            開啟
          </f7-swipeout-button>
          <f7-swipeout-button
            close
            overswipe
            color="gray"
            @click="navigateToSoldOutSettingPage(menu.variation, menu.version)">
            編輯
          </f7-swipeout-button>
        </f7-swipeout-actions>
      </f7-list-item>
      <f7-list-item title="設定檔" divider />
      <f7-list-item
        v-for="(draft, index) in menuDraftList"
        swipeout
        :key="`menu-list-draft-list-${index}`"
        :title="`${draft.title}`"
        :subtitle="draft.variation"
        :link="`/stores/${storeIdProp}/menu-drafts/${draft.variation}/menu-draft-actions`" />
      <f7-button raised fill @click="createDraft">新增草稿</f7-button>
    </f7-list>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  dependencies: ['apiStateType'],
  data () {
    return {
      menuList: []
    }
  },
  computed: {
    ...mapState('menuModule', ['menuVariations']),
    ...mapState('menuDraftModule', [
      'currentDraft',
      'createDraftState',
      'deleteDraftState',
      'menuDraftList',
      'modificationCount'
    ]),
    ...mapGetters(['storeId'])
  },
  watch: {
    store () { this.getMenuList() },
    createDraftState (type) {
      if (type === this.apiStateType.error) {
        this.$f7.dialog.alert('失敗', '新增草稿失敗')
        this.setCreateDraftState({ type: this.apiStateType.idle })
      } else if (type === this.apiStateType.ok) {
        this.setCreateDraftState({ type: this.apiStateType.idle })
      }
    },
    deleteDraftState (type) {
      if (type === this.apiStateType.error) {
        this.$f7.dialog.alert('失敗', '刪除草稿失敗')
        this.setDeleteDraftState({ type: this.apiStateType.idle })
      } else if (type === this.apiStateType.ok) {
        this.setDeleteDraftState({ type: this.apiStateType.idle })
      }
    }
  },
  async created () {
    if (!this.storeId) {
      await this.setStore(this.storeIdProp)
    }
    // TODO: 檢查是否已經有值，如果已經下載過就不用再下載？
    this.getMenuDraftList()
    this.getMenuVariations()
  },
  props: {
    storeIdProp: String
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('menuModule', ['getMenuVariations']),
    ...mapActions('menuDraftModule', [
      'getMenuDraftList',
      'createDraft',
      'setCreateDraftState',
      'setDeleteDraftState',
      'saveDraft',
      'deleteDraft'
    ]),
    navigateToMenuPage (variation) {
      const variationString = variation === 'main' ? 'menu' : `menus/${variation}`
      window.open(`${process.env.VUE_APP_URLS_ORDER}/stores/${this.storeIdProp}/${variationString}`)
    },
    navigateToSoldOutSettingPage (variation, version) {
      this.$f7router.navigate(`/stores/${this.storeIdProp}/menus/${variation}/${version}/sold-out-setting`)
    },
    pageBeforeIn () {
      if (this.modificationCount !== 0) {
        this.saveDraft(this.currentDraft.variation)
      }
    }
  }
}
</script>
